// src/components/HeaderCount/HeaderCount.jsx
import React, { useEffect, useState } from "react";
import StatisticsSection from "./StatisticsSection";
import { getGroupsCount } from "../../services/groupServices";
import { getEnseignantsCount } from "../../services/adherentServices";
import {
  comptageInscriptionsTotales,
  comptageStatutLicencie,
} from "../../services/dashboardServices";

const HeaderCount = () => {
  const [stats, setStats] = useState({
    licencies: 0,
    groupes: 0,
    enseignants: 0,
    inscritsEtCoursEssai: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const [g, e, ins, lic] = await Promise.all([
          getGroupsCount(),                 // -> number
          getEnseignantsCount(),            // -> number
          comptageInscriptionsTotales(),    // -> { nombreInscrits }
          comptageStatutLicencie(),         // -> { nombreAdherents }
        ]);

        if (!mounted) return;
        setStats({
          licencies: Number(lic?.nombreAdherents || 0),
          groupes: Number(g || 0),
          enseignants: Number(e || 0),
          inscritsEtCoursEssai: Number(ins?.nombreInscrits || 0),
        });
      } catch (err) {
        console.error("[HeaderCount] load error:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <StatisticsSection
      title="QUELQUES CHIFFRES"
      backgroundUrl="/img/HeaderCount2.png"
      loading={loading}
      licencies={stats.licencies}
      groupes={stats.groupes}
      enseignants={stats.enseignants}
      inscritsEtCoursEssai={stats.inscritsEtCoursEssai}
    />
  );
};

export default HeaderCount;
